/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../controller/controller.ts"/>

namespace DealerwareWebComponents {
    "use strict";

    import MobilityWebController =  MobilityWebCoreComponents.MobilityWebController;

    export interface IDealerwareCustomerFormController extends IDealerwareController {
        customer: any;
        $dealerwareCustomerFactory: any;
        onSaveSuccess: any;
        onSaveError: any;
        onCancel: any;

        saveCustomer() : void;
        cancel() : void;
        ccpaDeleteCustomer(): void;
    }

    export class CustomerFormController implements IDealerwareCustomerFormController {
        public static $inject : string[] = ['$timeout','$dealerwareCustomerFactory'];
        public customer: any;
        public onSaveSuccess: any;
        public onSaveError: any;
        public onCancel: any;

        constructor(public $timeout : any,public $dealerwareCustomerFactory : any) {
            if (!this.customer) {
                this.customer = this.$dealerwareCustomerFactory.getInstance();
            }
        }

        public saveCustomer() : void {
            alert("Needs to be implemented in subclass!");
        };

        public cancel() : void {
            if (this.onCancel && angular.isFunction(this.onCancel)) {
                this.onCancel();
            }
        };
    }
}